function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "empre-path-1",
  points: "0.0008 0.1467 30.037 0.1467 30.037 15.9997 0.0008 15.9997"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "empre-path-3",
  points: "0.0593353435 0.808 3.26883243 0.808 3.26883243 8.1608 0.0593353435 8.1608"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "empre-path-5",
  points: "0.0570720754 0.808 3.26655273 0.808 3.26655273 8.1608 0.0570720754 8.1608"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 10.192200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "empre-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#empre-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.3998,2.2437 L23.6378,2.2437 C23.2258,7.8967 19.5168,12.3347 15.0188,12.3347 C10.5198,12.3347 6.8118,7.8967 6.3998,2.2437 M25.4728,4.2507 C25.4808,4.2457 25.4898,4.2467 25.4978,4.2417 C26.3228,3.7397 27.4048,4.0017 27.9088,4.8277 C28.1528,5.2277 28.2258,5.6997 28.1148,6.1557 C28.0038,6.6107 27.7238,6.9947 27.3228,7.2387 C26.9218,7.4837 26.4508,7.5557 25.9958,7.4467 C25.5408,7.3357 25.1548,7.0547 24.9118,6.6537 C24.8918,6.6207 24.8618,6.5997 24.8368,6.5727 C25.1058,5.8317 25.3168,5.0547 25.4728,4.2507 M24.9698,12.2357 C23.8398,12.1567 22.5468,12.0937 21.1528,12.0467 C22.4258,10.9487 23.5008,9.5257 24.2908,7.8697 C24.6758,8.2557 25.1558,8.5367 25.6988,8.6687 C25.9368,8.7267 26.1768,8.7547 26.4158,8.7547 C26.9618,8.7547 27.4998,8.6047 27.9778,8.3137 C28.6658,7.8947 29.1488,7.2337 29.3378,6.4517 C29.5288,5.6697 29.4018,4.8607 28.9838,4.1737 C28.2818,3.0217 26.9268,2.5217 25.6818,2.8307 C25.7368,2.2937 25.7728,1.7507 25.7728,1.1957 C25.7728,0.6167 25.3038,0.1467 24.7238,0.1467 L5.3128,0.1467 C4.7338,0.1467 4.2638,0.6167 4.2638,1.1957 C4.2638,5.6847 6.0928,9.6527 8.8788,12.0477 C7.4858,12.0947 6.1948,12.1577 5.0678,12.2357 C1.1408,12.5107 0.0008,12.7717 0.0008,13.9737 C0.0008,15.1747 1.1408,15.4367 5.0678,15.7107 C7.7288,15.8977 11.2628,15.9997 15.0188,15.9997 C18.7738,15.9997 22.3078,15.8977 24.9698,15.7107 C28.8958,15.4367 30.0378,15.1747 30.0378,13.9737 C30.0378,12.7717 28.8958,12.5107 24.9698,12.2357",
  fill: "#FEFEFE",
  mask: "url(#empre-mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.000000, 0.192200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "empre-mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#empre-path-3"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.5502,8.1588 L1.6092,8.1608 C1.8512,8.1608 2.0832,8.0468 2.2342,7.8548 C2.4012,7.6388 2.4462,7.3578 2.3532,7.1018 C2.3482,7.0888 1.8982,5.7748 2.4712,4.7148 C3.2072,3.4948 3.4312,2.5338 3.1542,1.7758 C2.8962,1.0758 2.3212,0.8718 2.2062,0.8378 C1.7972,0.7188 1.3432,0.9668 1.2252,1.3708 C1.1642,1.5738 1.1862,1.7868 1.2862,1.9728 C1.3872,2.1588 1.5542,2.2938 1.7552,2.3538 C1.7062,2.3398 1.6712,2.3248 1.6692,2.3238 C1.6842,2.3648 1.7992,2.7628 1.1412,3.8588 L1.0922,3.9388 C1.0472,4.0128 0.9972,4.0908 0.9462,4.1698 C0.0922,5.4788 -0.1418,6.4878 0.2302,7.2548 C0.5192,7.8548 1.1132,8.1168 1.5502,8.1588",
  fill: "#FEFEFE",
  mask: "url(#empre-mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 0.192200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "empre-mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#empre-path-5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.5473,8.1588 L1.6073,8.1608 C1.8483,8.1608 2.0813,8.0468 2.2313,7.8548 C2.3993,7.6388 2.4433,7.3578 2.3503,7.1018 C2.3463,7.0888 1.8963,5.7748 2.4693,4.7148 C3.2053,3.4948 3.4293,2.5338 3.1513,1.7758 C2.8933,1.0758 2.3193,0.8718 2.2033,0.8378 C1.7953,0.7188 1.3413,0.9668 1.2223,1.3708 C1.1613,1.5738 1.1843,1.7868 1.2843,1.9728 C1.3843,2.1588 1.5513,2.2938 1.7523,2.3538 C1.7033,2.3398 1.6693,2.3248 1.6663,2.3238 C1.6823,2.3648 1.7963,2.7628 1.1383,3.8588 L1.0903,3.9388 C1.0443,4.0128 0.9953,4.0908 0.9433,4.1698 C0.0903,5.4788 -0.1437,6.4878 0.2273,7.2548 C0.5173,7.8548 1.1103,8.1168 1.5473,8.1588",
  fill: "#FEFEFE",
  mask: "url(#empre-mask-6)"
}))));

var SvgEmployeeRestaurant = function SvgEmployeeRestaurant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmployeeRestaurant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/employee-restaurant.999c06c7.svg";
export { ForwardRef as ReactComponent };